import dynamic from 'next/dynamic'

export const widgetsProductType = {
  PUC_WIDGET_ACKODRIVE: dynamic(() => import('@components/MainWidget/Puc/pucWidget'), {
    ssr: true,
  }),
  RTO_VEHICLE_INFO_WIDGET_ACKODRIVE: dynamic(() => import('@components/MainWidget/RtoVehicleInfo/rtoVehicleInfoWidget'), {
    ssr: true,
  }),
  RTO_DETAIL_ACKODRIVE: dynamic(() => import('@components/MainWidget/RtoDetail/rtoDetailWidget'), {
    ssr: true,
  }),
  CHALLAN_WIDGET_ACKODRIVE: dynamic(() => import('@components/MainWidget/ChallanWidget/challanWidget'), {
    ssr: true,
  }),
}

export const ackoDriveWidgetType = (widgetType: string) => {
  const widgetMap = {
    PUC_WIDGET: 'PUC_WIDGET_ACKODRIVE',
    RTO_VEHICLE_INFO_WIDGET: 'RTO_VEHICLE_INFO_WIDGET_ACKODRIVE',
    RTO_WIDGET: 'RTO_DETAIL_ACKODRIVE',
    CHALLAN_WIDGET: 'CHALLAN_WIDGET_ACKODRIVE'
  }

  return widgetMap[widgetType]
}
